function AiSendIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 20 20' fill='currentColor' aria-hidden='true' {...props}>
      <path d='M2.94 2.94a1.5 1.5 0 0 1 1.6-.34l12.5 5.06c1.1.45 1.1 2.01 0 2.46l-12.5 5.06a1.5 1.5 0 0 1-2.06-1.6l.7-4.06a.5.5 0 0 1 .5-.41h7.5a.5.5 0 0 0 0-1h-7.5a.5.5 0 0 1-.5-.41l-.7-4.06a1.5 1.5 0 0 1 .36-1.6z' />
    </svg>
  )
}

export { AiSendIcon }
